module.exports = __webpack_public_path__ + "assets/pdf/BN03-cn-food-security.39bb42e8.pdf";